import React, { FunctionComponent } from 'react';

import PostsAnalyzeTab from 'posts/components/PostsAnalyzeTab';
import { useQuery } from 'react-query';
import {
  loadInstagramDetails,
  loadLinkedinDetails,
  loadTiktokDetails,
  loadYoutubeDetails,
} from 'posts/Requests';
import Loader from 'app/components/Loader';
import DraggableTweetsColumns from 'app/components/DraggableTweetsColumns';
import { Grid } from '@material-ui/core';
import { apiRoutes } from 'posts/utils/apiRoutes';
import { _t } from 'app/utils/i18n';
import TiktokPostAnalyzed from 'posts/components/TiktokPostAnalyzed';
import LinkedinPostAnalyzed from 'posts/components/LinkedinPostAnalyzed';
import YoutubePostAnalyzed from 'posts/components/YoutubePostAnalyzed';

interface Props {
  isReport?: boolean;
  isTemplate?: boolean;
  removeComments?: boolean;
  items?: any[];
  isPreview?: boolean;
  reportData?: any;
  sub_module?: string;
}

const renderInstagramPosts = (
  reportData: any,
  isPreview?: boolean,
  items?: any[],
) => {
  const { isLoading, data: instagramPosts } = useQuery(
    [
      'loadInstagramDetails',
      {
        body: { post_id: reportData?.items[0].id, is_sample: isPreview },
      },
    ],
    loadInstagramDetails,
  );
  if (isLoading) return <Loader />;
  return (
    <>
      <PostsAnalyzeTab
        data={instagramPosts}
        id={reportData?.items[0].id || 0}
        isPreview={isPreview}
        tabName=""
        setActiveTab={() => {}}
        openModalToAddInfluencer={() => {}}
        ShowConversation={true}
        items={items}
      />
      <Grid md={12}>
        <DraggableTweetsColumns
          customFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          filters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          items={items}
          isTemplate
          showAllColumn
          isMultiTweets
          slugName={apiRoutes.instagramPostCommentsTab}
          reftechSentmentHandler={() => {
            return undefined;
          }}
          setFilterIsLoading={() => {
            return undefined;
          }}
          tabName={_t('posts:comments')}
          filterIsLoading={false}
          compId={'posts_instagram_post'}
          hideSort
          tweetColumnFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          action={function (arg: {
            body: any;
            isInfluencerModule?: boolean | undefined;
          }): Promise<unknown> {
            throw new Error('Function not implemented.');
          }}
        />
      </Grid>
    </>
  );
};

const renderTiktokPosts = (
  reportData: any,
  isPreview?: boolean,
  items?: any[],
) => {
  const { isLoading, data: tiktokPosts } = useQuery(
    [
      'loadTiktokDetails',
      {
        body: { post_id: reportData?.items[0].id, is_sample: isPreview },
      },
    ],
    loadTiktokDetails,
  );
  if (isLoading) return <Loader />;
  return (
    <>
      <TiktokPostAnalyzed
        data={tiktokPosts}
        id={reportData?.items[0].id || 0}
        isReport={false}
        tabName=""
        isPreview={isPreview}
        setActiveTab={() => {}}
        items={items}
      />
      <Grid md={12}>
        <DraggableTweetsColumns
          customFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          filters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          items={items}
          isTemplate
          showAllColumn
          isMultiTweets
          slugName={apiRoutes.tiktokPostCommentsTab}
          reftechSentmentHandler={() => {
            return undefined;
          }}
          setFilterIsLoading={() => {
            return undefined;
          }}
          tabName={_t('posts:comments')}
          filterIsLoading={false}
          compId={'posts_tiktok_post'}
          hideSort
          tweetColumnFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          action={function (arg: {
            body: any;
            isInfluencerModule?: boolean | undefined;
          }): Promise<unknown> {
            throw new Error('Function not implemented.');
          }}
        />
      </Grid>
    </>
  );
};

const renderLinkedinPosts = (
  reportData: any,
  isPreview?: boolean,
  items?: any[],
) => {
  const { isLoading, data: linkedinPosts } = useQuery(
    [
      'loadLinkedinDetails',
      {
        body: { post_id: reportData?.items[0].id, is_sample: isPreview },
      },
    ],
    loadLinkedinDetails,
  );
  if (isLoading) return <Loader />;
  return (
    <>
      <LinkedinPostAnalyzed
        data={linkedinPosts}
        id={reportData?.items[0].id || 0}
        isReport={false}
        tabName=""
        isPreview={isPreview}
        setActiveTab={() => {}}
        items={items}
      />
      <Grid md={12}>
        <DraggableTweetsColumns
          customFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          filters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          items={items}
          isTemplate
          showAllColumn
          isMultiTweets
          slugName={apiRoutes.linkedinCommentsTab}
          reftechSentmentHandler={() => {
            return undefined;
          }}
          setFilterIsLoading={() => {
            return undefined;
          }}
          tabName={_t('posts:comments')}
          filterIsLoading={false}
          compId={'posts_linkedin_post'}
          hideSort
          tweetColumnFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          action={function (arg: {
            body: any;
            isInfluencerModule?: boolean | undefined;
          }): Promise<unknown> {
            throw new Error('Function not implemented.');
          }}
        />
      </Grid>
    </>
  );
};

const renderYoutubePosts = (
  reportData: any,
  isPreview?: boolean,
  items?: any[],
) => {
  const { isLoading, data: youtubePosts } = useQuery(
    [
      'loadYoutubeDetails',
      {
        body: {
          video_id: reportData?.items[0].id, is_sample: isPreview ,
        },
      },
    ],
    loadYoutubeDetails,
  );
  if (isLoading) return <Loader />;
  return (
    <>
      <YoutubePostAnalyzed
        data={youtubePosts}
        id={reportData?.items[0].id}
        isReport={false}
        tabName=""
        isPreview={isPreview}
        setActiveTab={() => {}}
        items={items}
      />
      <Grid md={12}>
        <DraggableTweetsColumns
          customFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          filters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          items={items}
          isTemplate
          showAllColumn
          isMultiTweets
          slugName={apiRoutes.youtubePostCommentsTab}
          reftechSentmentHandler={() => {
            return undefined;
          }}
          setFilterIsLoading={() => {
            return undefined;
          }}
          tabName={_t('posts:comments')}
          filterIsLoading={false}
          compId={'posts_youtube_video'}
          hideSort
          tweetColumnFilters={{
            is_sample: isPreview,
            post_id: reportData?.items[0].id || 0,
            id: `${reportData?.items[0].id}`,
          }}
          action={function (arg: {
            body: any;
            isInfluencerModule?: boolean | undefined;
          }): Promise<unknown> {
            throw new Error('Function not implemented.');
          }}
        />
      </Grid>
    </>
  );
};

const PostsPreview: FunctionComponent<Props> = ({
  items,
  isPreview,
  reportData,
  sub_module,
}) => {
  if (sub_module === 'TIKTOK')
    return <>{renderTiktokPosts(reportData, isPreview, items)}</>;

  if (sub_module === 'INSTAGRAM')
    return <>{renderInstagramPosts(reportData, isPreview, items)}</>;
  if (sub_module === 'LINKEDIN')
    return <>{renderLinkedinPosts(reportData, isPreview, items)}</>;
  if (sub_module === 'YOUTUBE')
    return <>{renderYoutubePosts(reportData, isPreview, items)}</>;
};

export default PostsPreview;
